'use client';

import React from 'react';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
import { Category } from '@/data/resources';
import Link from 'next/link';
import { useTranslation } from '@/hooks/useTranslation';

interface MobileNavProps {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  categories: Category[];
}

const MobileNav = ({ isOpen, setIsOpen, categories }: MobileNavProps) => {
  const { t } = useTranslation();
  
  return (
    <>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="lg:hidden p-2 rounded-md text-gray-600 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700"
        aria-label="Toggle menu"
      >
        {isOpen ? (
          <XMarkIcon className="h-6 w-6" />
        ) : (
          <Bars3Icon className="h-6 w-6" />
        )}
      </button>

      {isOpen && (
        <div className="fixed inset-0 z-50 bg-gray-900 bg-opacity-75 lg:hidden">
          <div className="fixed inset-y-0 left-0 w-64 bg-gray-900 text-white overflow-y-auto p-6 transform transition-transform ease-in-out duration-300">
            <div className="flex justify-between items-center mb-8">
              <Link href="/" className="text-2xl font-bold">
                {t('siteTitle')}
              </Link>
              <button
                onClick={() => setIsOpen(false)}
                className="p-2 rounded-md text-gray-300 hover:bg-gray-800"
                aria-label="Close menu"
              >
                <XMarkIcon className="h-6 w-6" />
              </button>
            </div>

            <nav>
              <ul className="space-y-4">
                {categories.map((category) => (
                  category.resources.length > 0 && (
                    <li key={category.id}>
                      <Link
                        href={`#${category.id}`}
                        className="block p-2 rounded hover:bg-gray-800 transition-colors duration-200"
                        onClick={() => setIsOpen(false)}
                      >
                        {t(category.id) !== category.id ? t(category.id) : category.name}
                      </Link>
                    </li>
                  )
                ))}
              </ul>
            </nav>
            
            {/* Footer with copyright information */}
            <div className="mt-auto pt-8 text-center text-gray-400 text-xs absolute bottom-6 left-0 right-0">
              <p>{t('copyright')}</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MobileNav; 